<template>
    <form class="card">
        <h3>Скидки</h3>
        <div class="inline">
            <div class="buttons-group inline">
                <div class="buttons-group-item" v-for="(item, key) in daysList" :key="key">
                    <input type="radio" :id="'day' + key" v-model="day" :value="key" @change="getData()" />
                    <label :for="'day' + key">{{ item }}</label>
                </div>
            </div>
            <div class="buttons-group inline">
                <div class="buttons-group-item" v-for="(item, key) in garageList" :key="key">
                    <input type="radio" :id="'garage' + key" v-model="garage" :value="key" @change="getData()" />
                    <label :for="'garage' + key">{{ item }}</label>
                </div>
            </div>
        </div>
        <div class="column" v-if="status == ''">
            <div class="discount-header" v-if="data">
                <span>1ч</span>
                <span>12ч</span>
                <span>24ч</span>
            </div>
            <div class="form-item range" v-for="(item, key) in data" :key="key">
                <p>{{ item.start }}</p>
                <span>&ndash;</span>
                <p>{{ item.end }}</p>
                <div class="inline">
                    <input type="text" class="text-input" v-model="item.discounts['1h']" />
                    <input type="text" class="text-input" v-model="item.discounts['12h']" />
                    <input type="text" class="text-input" v-model="item.discounts['24h']" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: ['status', 'data'],
        data () {
          return {
              daysList: {
                1: 'Пн-Пт',
                2: 'Суббота',
                3: 'Воскресенье',
                11: 'Сегодня',
                12: 'Завтра',
              },
              garageList: {
                1: 'Авто',
                2: 'Мото',
              },
              day: 11,
              garage: 1
          }
        },
        created () {
            this.getData()
        },
        methods: {
            getData () {
                this.$emit('getData', 'day=' + this.day + '&garage=' + this.garage)
            }
        }
    }
</script>